import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Card, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-hot-toast';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import './Login.css';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { handleLogin, handleGoogleLogin, user } = useAuth();

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      setLoading(true);
      await handleLogin(email, password);
      toast.success('Giriş başarılı!');
      navigate('/');
    } catch (error) {
      console.error('Login error:', error);
      setError(error.message || 'Giriş yapılırken bir hata oluştu');
      toast.error(error.message || 'Giriş yapılırken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const onGoogleSuccess = async (credentialResponse) => {
    try {
      setLoading(true);
      await handleGoogleLogin(credentialResponse);
      toast.success('Google ile giriş başarılı!');
      navigate('/');
    } catch (error) {
      console.error('Google login error:', error);
      setError(error.message || 'Google ile giriş yapılırken bir hata oluştu');
      toast.error(error.message || 'Google ile giriş yapılırken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const onGoogleError = () => {
    setError('Google ile giriş başarısız oldu. Lütfen tekrar deneyin.');
    toast.error('Google ile giriş başarısız oldu');
  };

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Container className="login-container page-transition">
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col md={6} lg={5}>
            <Card className="shadow-sm login-card">
              <Card.Body className="p-1">
                <div className="text-center mb-4">
                  <h2 className="fw-bold">Giriş Yap</h2>
                  <p className="text-muted">Hesabınıza giriş yapın</p>
                </div>

                {error && <Alert variant="danger">{error}</Alert>}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Email adresinizi girin"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={loading}
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Şifre</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Şifrenizi girin"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      disabled={loading}
                    />
                    <div className="d-flex justify-content-end mt-2">
                      <Link to="/forgot-password" className="text-decoration-none text-muted small">
                        Şifreni mi unuttun?
                      </Link>
                    </div>
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 mb-3"
                    disabled={loading}
                  >
                    {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
                  </Button>

                  <div className="text-center mb-3">
                    <p className="text-muted">veya</p>
                  </div>

                  <div className="google-login-container mb-3">
                    <GoogleLogin
                      onSuccess={onGoogleSuccess}
                      onError={onGoogleError}
                      useOneTap
                      theme="outline"
                      size="large"
                      width="100%"
                      text="continue_with"
                      locale="tr"
                    />
                  </div>

                  <div className="text-center">
                    <p className="mb-0">
                      Hesabınız yok mu?{' '}
                      <Link to="/register" className="text-primary text-decoration-none">
                        Kayıt Ol
                      </Link>
                    </p>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </GoogleOAuthProvider>
  );
}

export default Login;